import type { AvatarTone } from "../components/Thumbnail";

/** Same order as `Thumbnail` pastel tones (Figma avatar matrix). */
const AVATAR_TONE_ORDER: readonly AvatarTone[] = [
    "blue",
    "peach",
    "brown",
    "green",
    "orange",
    "purple",
    "yellow",
] as const;

/**
 * Derives up to two initials from a display name (e.g. `"Andreas Levin"` → `AL`,
 * `"osmany"` → `OS`).
 */
export function profileInitialsFromName(name: string): string {
    const trimmed = name.trim();
    if (!trimmed) {
        return "??";
    }
    const parts = trimmed.split(/\s+/).filter(Boolean);
    if (parts.length === 1) {
        return trimmed.slice(0, 2).toUpperCase();
    }
    const a = parts[0][0] ?? "";
    const b = parts[parts.length - 1][0] ?? "";
    return `${a}${b}`.toUpperCase();
}

/**
 * Picks a stable {@link AvatarTone} from a string (user id, email, username).
 *
 * Prefer this over `Math.random()` so the same person always gets the same
 * pastel until you pass an explicit `avatarTone` from the server.
 */
export function avatarToneFromSeed(seed: string): AvatarTone {
    if (!seed) {
        return "green";
    }
    let h = 0;
    for (let i = 0; i < seed.length; i += 1) {
        h = (h * 31 + seed.charCodeAt(i)) | 0;
    }
    const idx = Math.abs(h) % AVATAR_TONE_ORDER.length;
    return AVATAR_TONE_ORDER[idx] ?? "green";
}
